import { render, staticRenderFns } from "./Register-company.vue?vue&type=template&id=41267a8e"
import script from "./Register-company.vue?vue&type=script&lang=js"
export * from "./Register-company.vue?vue&type=script&lang=js"
import style0 from "./Register-company.vue?vue&type=style&index=0&id=41267a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports